import {openDialog, closeDialog} from 'vue3-promise-dialog';
import MsMessageBox from '@/components/messageBox/MsMessageBox.vue';
import MsBottomRightMessageBox from '@/components/messageBox/MsBottomRightMessageBox.vue';
import MsShowingContextMenu from '@/components/messageBox/MsShowingContextMenu.vue';
import MsCorrectWordPopup from '@/components/popup/MsCorrectWordPopup.vue';
import MsProgressPostMulti from '@/components/messageBox/MsProgressPostMulti.vue';

async function getProgress(title, dataRow, start, end, sessionId, data) {
  return {
    title,
    dataRow,
    start,
    end,
    sessionId,
    data,
  };
}

function getMsgOption(type, message, title, width, textBtn) {
  if (typeof message === 'object' && message.message) {
    return {...message, ...{type}};
  } else {
    return {
      type,
      message: message,
      title: title,
      width,
      textBtn,
    };
  }
}

function getMsgOptionCustom(type, message, title, customButton, width, customLabelCheckbox) {
  if (typeof message === 'object' && message.message) {
    return {...message, ...{type}};
  } else {
    return {
      type,
      message: message,
      title: title,
      customButton,
      width,
      customLabelCheckbox,
    };
  }
}

function getMsgOptionFnCustom(type, message, title, width, fnEventCustom) {
  if (typeof message === 'object' && message.message) {
    return {...message, ...{type}};
  } else {
    return {
      type,
      message: message,
      title: title,
      width,
      fnEventCustom,
    };
  }
}

export function showAlert(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showInfo(message, title, width, textBtn) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width, textBtn));
}
export function showSuccess(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(0, message, title, width));
}
export function showError(message, title, width, textBtn, type = 0) {
  return openDialog(MsMessageBox, getMsgOption(type, message, title, width, textBtn));
}
export function showConfirm(message, title, width, textBtn) {
  return openDialog(MsMessageBox, getMsgOption(1, message, title, width, textBtn));
}
export function showConfirmCancel(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(2, message, title, width));
}
export function showConfirmDelete(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(3, message, title, width));
}
export function showConfirmClose(message, title, width, customTextButton) {
  return openDialog(MsMessageBox, getMsgOptionCustom(4, message, title, customTextButton, width));
}
export function showErrorCustom(message, title, type, width) {
  return openDialog(MsMessageBox, getMsgOption(type, message, title, width));
}

export function showConfirmWithCustomBtn(message, title, width, customButton) {
  return openDialog(MsMessageBox, getMsgOptionCustom(1, message, title, customButton, width));
}

/**
 * @param {string} message Nội dung
 * @param {string} title Tiêu đề
 * @param {{Yes: string,  No: string}} customButton CustomButton
 * @param {number} width Độ rộng của MsMessageBox
 * @returns
 * KHI THÊM THAM SỐ LƯU Ý BỔ SUNG THÊM TRONG CẢ orderPopupStore.js (nvxuan 20.02.2024)
 */
export function showConfirmValidate(message, title, customButton, width) {
  return openDialog(MsMessageBox, getMsgOptionCustom(5, message, title, customButton, width));
}
export function showConfirmValidateCustom(message, title, textBtn, width) {
  return openDialog(MsMessageBox, getMsgOption(6, message, title, width, textBtn));
}
/**
 * Dialog show confirm với checkbox không hiển thị lại lần sau
 * TVDAT 05.07.2022
 */
export function showConfirmWithDontShowAgain(message, title, customLabelCheckbox, textBtn, width) {
  return openDialog(MsMessageBox, {
    type: 7,
    message,
    title,
    width,
    textBtn,
    customLabelCheckbox,
  });
}

export function showIncurredDataWarning(message, title, width) {
  return openDialog(MsMessageBox, getMsgOption(8, message, title, width));
}

export function showChooseOptionConfirm(message, optionList, title, width) {
  return openDialog(MsMessageBox, {
    type: 9,
    message: message,
    title: title,
    width,
    optionList,
    width: 500,
  });
}

/**
 * Dia log chọn theo chiều dọc
 * @param {*} message
 * @param {*} optionList
 * @param {*} title
 * @param {*} width
 * @returns
 */
export function showChooseOptionConfirmVertical(message, optionList, title, width = 500, optionDefault = 1) {
  return openDialog(MsMessageBox, {
    type: 18,
    message: message,
    title: title,
    width,
    optionList,
    optionDefault,
  });
}

/**
 * Show form xác nhận tự động hạch toán đồng thời
 * @param {*} message
 * @param {*} title
 * @param {*} customButton
 * @param {*} width
 * @param {*} customLabelCheckbox
 * @return
 * NVTUAN1 01.08.2022
 */
export function showConfirmAutoGenerateParallel(message, title, customButton, width, customLabelCheckbox) {
  return openDialog(MsMessageBox, getMsgOptionCustom(10, message, title, customButton, width, customLabelCheckbox));
}

export function showConfirmIncurredData(message, title, width, textBtn) {
  return openDialog(MsMessageBox, getMsgOption(20, message, title, width, textBtn));
}

/**
 * show confirm mapping chứng từ hạch toán
 * nhhoang1 01.04.2024
 */
export function showConfirmMappingVoucher(message, title, width, fnEventCustom) {
  return openDialog(MsMessageBox, getMsgOptionFnCustom(21, message, title, width, fnEventCustom));
}

/**
 * Mở popup góc phải màn hình
 * @param {*} message
 * @param {*} title
 * @returns
 */
export function showBottomRightDialog(message, title) {
  return openDialog(MsBottomRightMessageBox, getMsgOption(0, message, title));
}

/**
 * show dropdown tùy chỉnh dòng
 * @param {*} title Tên popup
 * @param {*} position Vị trí muốn show
 * @param {*} model Model truyền vào
 * @param {*} timer timer tự tắt của popup
 * @returns
 */
export function showOptionContextMenu(title, position, model, timer) {
  const options = {title, width: 400, type: 1, position, model, timer};
  return openDialog(MsShowingContextMenu, options);
}

export function close(data) {
  closeDialog(data);
}

export function showListCorrectWord(position) {
  return openDialog(MsCorrectWordPopup, position);
}


/**
 * Mở progress cho ghi sổ/ bỏ ghi sổ nhiều chứng từ
 * ntduong2 13.11.2024
 */
export async function showProgressPostedMulti(title, data) {
  return openDialog(MsProgressPostMulti, await getProgress(title, null, null, null, null, data));
}
